import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard } from '@fortawesome/free-regular-svg-icons';
import { faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import Whistle from 'assets/Whistle';
import { Dropdown } from 'styles';

const LeagueDropdown = () => {
  return (
    <Dropdown>
      <h3>League</h3>
      <ul>
        <li>
          <Link to="/rules">
            <FontAwesomeIcon icon={faBalanceScale} />
            League Rules
          </Link>
        </li>
        <li>
          <Link to="/refs">
            <Whistle />
            Referee Guidelines
          </Link>
        </li>
        <li>
          <Link to="/scorekeeping">
            <FontAwesomeIcon icon={faClipboard} />
            Scorekeeping Info
          </Link>
        </li>
      </ul>
    </Dropdown>
  );
};

export default LeagueDropdown;
